import useSWR from "swr"
import useSWRMutation from "swr/mutation"
import type { CreateProVenueInstanceRequest, ProVenueConfigType, UpdateProVenueInstanceRequest } from "@/types/provenue-instance"
import { proVenueInstanceService } from "@/services/provenue-instance-service"

export const PROVENUE_INSTANCES_KEY = ["provenue-instances"]

export function useProVenueInstances(configType: ProVenueConfigType) {
  return useSWR([...PROVENUE_INSTANCES_KEY, configType], () => proVenueInstanceService.getAll(configType), {
    revalidateOnFocus: false,
    shouldRetryOnError: false,
  })
}

export function useCreateProVenueInstance(configType: ProVenueConfigType) {
  return useSWRMutation([...PROVENUE_INSTANCES_KEY, configType], (_key: string[], { arg }: { arg: Omit<CreateProVenueInstanceRequest, "configType"> }) => proVenueInstanceService.create({ ...arg, configType }))
}

export function useUpdateProVenueInstance(id: number) {
  return useSWRMutation(["provenue-instances", "update", id], (_key, { arg }: { arg: UpdateProVenueInstanceRequest }) => proVenueInstanceService.update(id, arg))
}

export function useDeleteProVenueInstance() {
  return useSWRMutation(["provenue-instances", "delete"], (_key, { arg }: { arg: number }) => proVenueInstanceService.delete(arg))
}
